import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonV2 } from "../ButtonV2/ButtonV2";
import { InputV2 } from "../InputV2/InputV2";

interface MinutesInputProps {
    label?: string,
    value: number;
    onChange: (value: number) => void;
    disabled?: boolean;
  }
  
  export function CounterInput({ label = '', value, onChange, disabled = false }: MinutesInputProps) {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState(value.toString());
  
    useEffect(() => {
        setInputValue(value.toString());
      }, [value]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (disabled) return;
        const newValue = e.target.value.replace(/[^0-9]/g, '');
        setInputValue(newValue);
        onChange(parseInt(newValue) || 0);
      };
    
      const handleIncrement = () => {
        if (disabled) return;
        const newValue = Math.min(value + 10, 1440); // Max 24 hours
        setInputValue(newValue.toString());
        onChange(newValue);
      };
    
      const handleDecrement = () => {
        if (disabled) return;
        const newValue = Math.max(value - 10, 0);
        setInputValue(newValue.toString());
        onChange(newValue);
      };
  
    return (
        <div className={`${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
            {label && <p className="text-sm font-extrabold">{t(label)}:</p>}
            <div className="flex items-center space-x-2">
                <ButtonV2 
                onClick={handleDecrement} 
                variant="outline" 
                size="icon" 
                disabled={disabled}
                >
                -10
                </ButtonV2>
                <InputV2
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                className="w-20 text-center"
                disabled={disabled}
                />
                <ButtonV2 
                onClick={handleIncrement} 
                variant="outline" 
                size="icon"
                disabled={disabled}
                >
                +10
                </ButtonV2>
            </div>
        </div>
    );
  }